if (!customElements.get('drawer-section')) {
  class DrawerSection extends HTMLElement {
    constructor() {
      super();
      this.header = document.querySelector('.header');
      this.content = this.querySelector('.drawer__content');
      this.gallery = this.querySelector('.drawer__gallery');
      this.scrollbars = [];

      this.addEventListener('click', () => {
        this.close();
      });

      this.querySelectorAll('[data-drawer-close]').forEach((e) => {
        e.addEventListener('click', () => {
          this.close();
        });
      });

      this.content.addEventListener('click', (e) => {
        e.stopPropagation();
      });

      if (this.gallery) {
        this.gallery.addEventListener('click', (e) => {
          e.stopPropagation();
        });
      }

      if (typeof PerfectScrollbar === 'function') {
        this.querySelectorAll('.drawer__scroll').forEach((e) => {
          this.scrollbars.push(
            new PerfectScrollbar(e, {
              suppressScrollX: true,
              wheelPropagation: true,
              swipeEasing: true,
              minScrollbarLength: 0,
            })
          );
        });
      }

      let resizeObserver = new ResizeObserver(() => {
        this.scrollbars.forEach((s) => s.update());
      });

      resizeObserver.observe(this.content);
      this.querySelectorAll('.drawer__scroll-inner').forEach((e) => resizeObserver.observe(e));

      this.addEventListener('drawerResize', () => {
        this.scrollbars.forEach((s) => s.update());
      });

      this.getScrollbarCompensation = () => {
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        return scrollbarWidth > 0 ? `${scrollbarWidth}px` : '';
      };

      DrawerSection.installHistoryPatch();

      if (!DrawerSection.historyListenerAdded) {
        window.addEventListener('popstate', () => {
          const drawer = DrawerSection.getHistoryDrawer();
          if (!drawer) return;

          window.__drawerHandledPopstate = true;
          DrawerSection.isHistoryNavigation = true;
          drawer.close();
          DrawerSection.isHistoryNavigation = false;
          setTimeout(() => {
            window.__drawerHandledPopstate = false;
          });
        });
        DrawerSection.historyListenerAdded = true;
      }

      window.addEventListener('drawerOpen', (e) => {
        if (e.detail.id == this.id) {
          this.open();
        }
      });

      window.addEventListener('drawerClose', () => {
        this.close();
      });

      window.addEventListener('drawerResize', () => {
        this.scrollbars.forEach((s) => s.update());
      });

      window.addEventListener('escPressed', () => {
        this.close();
      });
    }

    open() {
      let scrollY;
      const scrollbarCompensation = this.getScrollbarCompensation();
      this.style.display = 'flex';

      this.pushHistoryState();

      if (!document.body.classList.contains('drawer-locked')) {
        scrollY = window.scrollY || window.pageYOffset;
        document.body.dataset.drawerScrollY = '' + scrollY;
        document.body.style.top = `-${scrollY}px`;
        document.body.classList.add('drawer-locked');
      }

      document.body.style.overflow = 'hidden';
      if (scrollbarCompensation) {
        document.body.style.paddingRight = scrollbarCompensation;
        if (this.header) {
          this.header.style.paddingRight = scrollbarCompensation;
        }
      }

      setTimeout(() => {
        this.classList.add('drawer--opened');
        if (this.id === 'drawer-search') {
          const input = this.querySelector('input[name="q"]');
          if (input) input.focus();
        }
        if (this.id === 'drawer-fabric-select') {
          this.querySelectorAll('.drawer__gallery-item img').forEach((img) => (img.loading = 'eager'));
        }
      });

      setTimeout(() => {
        this.scrollbars.forEach((s) => s.update());
      }, 100);
      setTimeout(() => {
        this.scrollbars.forEach((s) => s.update());
      }, 300);
    }

    close() {
      if (this.shouldRestoreHistoryOnClose()) {
        history.back();
        return;
      }

      this.removeHistoryState();
      this.classList.remove('drawer--opened');

      setTimeout(() => {
        this.style.display = 'none';

        // Only unlock body and reset styles if no other drawer is open
        if (!document.querySelector('.drawer.drawer--opened')) {
          document.body.style.removeProperty('overflow');
          document.body.style.removeProperty('padding-right');
          document.body.style.removeProperty('top');

          if (document.body.classList.contains('drawer-locked')) {
            document.body.classList.remove('drawer-locked');
            const scrollY = parseInt(document.body.dataset.drawerScrollY || '0', 10);
            delete document.body.dataset.drawerScrollY;
            window.scrollTo(0, scrollY);
          }

          if (this.header) {
            this.header.style.removeProperty('padding-right');
          }
        }
      }, 400);

      window.dispatchEvent(new CustomEvent('drawerClosed', { detail: { id: this.id } }));
    }

    isMobilePdpDrawer() {
      return window.matchMedia('(max-width: 767px)').matches && document.querySelector('.product');
    }

    pushHistoryState() {
      if (!this.isMobilePdpDrawer()) return;
      if (DrawerSection.historyIds[DrawerSection.historyIds.length - 1] === this.id) return;

      const currentState = history.state && typeof history.state === 'object' ? history.state : {};
      DrawerSection.activeHistoryDrawer = this;
      DrawerSection.isUpdatingHistory = true;
      DrawerSection.nativePushState.call(
        history,
        Object.assign({}, currentState, { drawerId: this.id }),
        '',
        window.location.href,
      );
      DrawerSection.isUpdatingHistory = false;
      DrawerSection.historyIds.push(this.id);
    }

    shouldRestoreHistoryOnClose() {
      return (
        this.isMobilePdpDrawer() &&
        !DrawerSection.isHistoryNavigation &&
        DrawerSection.historyIds[DrawerSection.historyIds.length - 1] === this.id
      );
    }

    removeHistoryState() {
      if (DrawerSection.historyIds[DrawerSection.historyIds.length - 1] === this.id) {
        DrawerSection.historyIds.pop();
      }
      if (!DrawerSection.historyIds.length) {
        DrawerSection.activeHistoryDrawer = null;
      }
    }

    static getHistoryDrawer() {
      const drawerId = DrawerSection.historyIds[DrawerSection.historyIds.length - 1];
      if (!drawerId) return null;

      return document.getElementById(drawerId);
    }

    static installHistoryPatch() {
      if (DrawerSection.historyPatchInstalled) return;

      DrawerSection.nativePushState = history.pushState;
      DrawerSection.nativeReplaceState = history.replaceState;

      history.pushState = function (state, title, url) {
        const drawer = DrawerSection.activeHistoryDrawer;
        if (drawer && drawer.isMobilePdpDrawer() && !DrawerSection.isUpdatingHistory) {
          DrawerSection.nativeReplaceState.call(history, state, title, url);
          drawer.removeHistoryState();
          drawer.pushHistoryState();
          return;
        }

        return DrawerSection.nativePushState.call(history, state, title, url);
      };

      DrawerSection.historyPatchInstalled = true;
    }
  }

  DrawerSection.historyIds = [];
  DrawerSection.historyListenerAdded = false;
  DrawerSection.historyPatchInstalled = false;
  DrawerSection.isHistoryNavigation = false;
  DrawerSection.isUpdatingHistory = false;
  DrawerSection.activeHistoryDrawer = null;
  DrawerSection.nativePushState = history.pushState;
  DrawerSection.nativeReplaceState = history.replaceState;

  customElements.define('drawer-section', DrawerSection);
}
